import { useState } from 'react';
import { useMapElement } from '../contextProviders/MapElementProvider';
import NameInput from '../common/NameInput';
import ProcessList from './ProcessList';
import OutcomeList from '../common/outcomes/OutcomeList';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import { isNullOrWhitespace } from '../../../../utils/guard';
import type { MapElementRequestAPI } from '../../../../sources/graph';
import FormGroup from '../../../generic/FormGroup';
import Footer from '../common/Footer';
import translations from '../../../../translations';

const ProcessConfiguration = () => {
    const { mapElement, onSaveMapElement, onClose, onUpdateName, setMapElement } = useMapElement();
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const isFormValid = isNullOrWhitespace(mapElement?.developerName) === false;

    const onSave = () => {
        setHasSubmitted(true);

        if (isFormValid) {
            onSaveMapElement(mapElement as MapElementRequestAPI);
        }
    };

    if (!mapElement) {
        onClose();
        return;
    }

    const renderBody = () => (
        <>
            <NameInput
                isValid={isFormValid}
                showValidation={hasSubmitted}
                id="process-name"
                name={mapElement.developerName ?? ''}
                onUpdateName={onUpdateName}
            />
            <ProcessList />
            <OutcomeList />
            <FormGroup
                key="process-comments"
                label={translations.PROCESS_comments_label}
                htmlFor="process-comments"
            >
                <textarea
                    id="process-comments"
                    data-testid="process-comments"
                    className="form-control form-textarea"
                    value={mapElement.developerSummary ?? ''}
                    onChange={({ target: { value } }) => {
                        setMapElement({
                            ...mapElement,
                            developerSummary: value,
                        });
                    }}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => (
        <>
            <Footer save={onSave} cancel={onClose} />
        </>
    );

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default ProcessConfiguration;
